import React, { FC, ReactElement } from 'react';
import Icon from '../../../Icon';
import { VideoProps } from '../DemoZone';
import './demozone-videos.sass';
import { useSelector } from 'react-redux';
import localeFieldResolver from '../../../../helpers/locale-field-finder';
import { internalizationState } from '../../../../stores/reducers/sections';
import { getContentDataIntro } from '../../../../stores/reducers/userData';

interface Props {
  video: VideoProps;
  playVideo(videoId: string, isVideoStart: boolean): void;
}
  
const DemoZoneVideoItem: FC<Props> = ({ video, playVideo }): ReactElement => {
  const { activeLangState } = useSelector(internalizationState);
  const { backendURL } = useSelector(getContentDataIntro);

  return (
    <div className="video-preview-container">
      <div className="video-preview-container__image">
        <img className="img-responsive" src={video.preview ? backendURL + video.preview : `https://img.youtube.com/vi/${video.youtubeKey}/0.jpg`} alt="" />
        <div className="about-video__play">
          <button className="play-video-btn" type="button" onClick={() => playVideo(video.youtubeKey, true)}>
            <Icon name="play" />
          </button>
        </div>
      </div>
      <p className="video-preview-container__title">
        { localeFieldResolver(video, 'title', activeLangState) }
      </p>
      <p className="video-preview-container__description">
        { localeFieldResolver(video, 'description', activeLangState) }
      </p>
    </div>
  )
}

export default DemoZoneVideoItem;
